import { Injectable } from '@angular/core';
import { HttpWrapper } from '../shared/services';
import { Observable } from 'rxjs';

export interface PriceIndex {
  provider: string;
  timestamp: number;
  index: string;
  productId: string;
  price: number;
  isDeleted: boolean;
}

export interface PriceIndexDescription {
  indexName: string;
  products: string[];
}

export interface PriceProvider {
  providerName: string;
  indexes: PriceIndexDescription[];
}

export interface MarketPublicationConfig {
  publication: string;
  senderEmailAddress: string;
  datePattern: string;
  attachmentRegexPattern: string;
}

export interface MarketPublisher {
  publisher: string;
  receiverEmailAddress: string;
  publications: MarketPublicationConfig[];
}

export interface MarketDoc {
  publisher: string;
  fileName: string;
  timestamp: number;
  docId: string;
}

@Injectable({providedIn : 'root'})
export class MarketService {

  constructor(private _httpWrapper: HttpWrapper) { }

  add(data: PriceIndex): Promise<PriceIndex | undefined> {
    return this._httpWrapper.post<PriceIndex, PriceIndex>('pricing', data).toPromise();
  }

  getPrices(startTimestamp: number, endTimestamp: number): Observable<PriceIndex[]> {
    return this._httpWrapper.get<PriceIndex[]>(`pricing?endTime=${endTimestamp}&startTime=${startTimestamp}`);
  }

  getExcelReport(startTimestamp: number, endTimestamp: number) {
    return this._httpWrapper.download(`pricing/excel?&endTime=${endTimestamp}&startTime=${startTimestamp}`);
  }

  getAll(startTimestamp: number, endTimestamp: number): Promise<PriceIndex[] | undefined> {
    return this._httpWrapper.get<PriceIndex[]>(`pricing?endTime=${endTimestamp}&startTime=${startTimestamp}`).toPromise();
  }

  getPublisherDocs(startTimestamp: number, endTimestamp: number): Observable<MarketDoc[]> {
    return this._httpWrapper.get<MarketDoc[]>(`pricing/documents?&endTime=${endTimestamp}&startTime=${startTimestamp}`);
  }

  getProviders() {
    return this._httpWrapper.get<PriceProvider[]>('pricing/providers');
  }

  getMarketPublishers() {
    return this._httpWrapper.get<MarketPublisher[]>('publishers');
  }

  importPriceFile(publisher: string, publicationName: string, date: string, fileList: FileList): Observable<PriceIndex[]> {
    return this._httpWrapper.postMultiPart(
      `pricing/reimport/${publisher}/${encodeURIComponent(publicationName)}/${date}`, this.toFormData(publisher, fileList));
  }

  private toFormData(docType: string, fileList: FileList) {
    const formData = new FormData();
    formData.append('documentType', docType);
    const file = fileList.item(0);
    if (file) {
      formData.append('file', file);
    }
    return formData;
  }
}
